export const getIconPath = (symbol: string): string => {
    const svgs = ['pm', 'uusd'];
    if (svgs.includes(symbol.toLowerCase())) return `/assets/images/coins/${symbol.toLowerCase()}.svg`;

    return `/assets/images/coins/${symbol.toLowerCase()}.svg`;
};
